// ============================================================
// 🔧 Replace these values with your real credentials
// ============================================================

// --- FIREBASE ---
export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyDiFLb33NJ5nAw7sNazM0RpEC6rV9-GnsQ",
  authDomain: "lets-talk-llc.firebaseapp.com",
  projectId: "lets-talk-llc",
  storageBucket: "lets-talk-llc.firebasestorage.app",
  messagingSenderId: "1050001941141",
  appId: "1:1050001941141:web:8342ba8b124724390c319c",
};

// --- CLOUDINARY ---
export const CLOUDINARY_CONFIG = {
  cloudName: "dgwrnc2g4",
  uploadPreset: "let-talk-llc",
};

// --- ADMIN ---
// The email you register as your admin user in Firebase Console →
// Authentication → Users → Add user
export const ADMIN_EMAIL    = "admin@letstalk.llc"; // ← change to your admin email
export const ADMIN_PASSWORD = "admin@123";             // ← change to a strong password

// --- LOGO ---
export const LOGO_URL = "/logo.png";
